import { produce } from 'immer';
import {
    GET_GOOGLE_ASSIGNMENT_ERROR,
    GET_GOOGLE_ASSIGNMENT_START,
    GET_GOOGLE_ASSIGNMENT_SUCCESS,
    SET_ASSIGNMENT_ERROR,
} from '../actions/assignment';

export const initialState = {
    httpStatus: {
        error: false,
        fetching: false,
        loaded: false,
        created: false,
        errorbody: undefined,
    },
    status: {
        error: false,
        errorType: undefined,
    },
};

export const GET_ASSIGNMENT_SUCCESS = 'GET_ASSIGNMENT_SUCCESS';
export const GET_ASSIGNMENT_START = 'GET_ASSIGNMENT_START';
export const GET_ASSIGNMENT_ERROR = 'GET_ASSIGNMENT_ERROR';

export const reducer = produce((state = initialState, action = {}) => {
    switch (action.type) {
        case GET_ASSIGNMENT_START:
            return {
                ...state,
                httpStatus: { ...state.httpStatus, fetching: true },
            };
        case GET_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                ...action.payload,
                httpStatus: { ...state.httpStatus, fetching: false, loaded: true },
            };
        case GET_ASSIGNMENT_ERROR:
            return {
                ...state,
                httpStatus: { ...state.httpStatus, error: true },
            };
        case GET_GOOGLE_ASSIGNMENT_START:
            return {
                ...state,
                httpStatus: { ...state.httpStatus, fetching: true },
            };
        case GET_GOOGLE_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                endDate: action.payload,
                httpStatus: { ...state.httpStatus, fetching: false, loaded: true },
            };
        case GET_GOOGLE_ASSIGNMENT_ERROR:
            return {
                ...state,
                httpStatus: { ...state.httpStatus, error: true },
            };
        case SET_ASSIGNMENT_ERROR:
            return {
                ...state,
                status: {
                    error: true,
                    errorType: action.payload,
                },
            };
        default:
            return state;
    }
});
